import {RootState} from "./rootReducer";

const getRootState = (v: RootState) => v;

export default getRootState;
